module.exports = __webpack_public_path__ + "img/Hair.9bcbb143.jpg";